import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { auth } from "../../firebase";
import useCurrentUser from "../../hooks/useCurrentUser";
import { HASBRO_BRAND } from "./hasbroTheme";

// /hasbro-customer portal: logins Hasbro created for its customers. The customer link is a
// custom claim on the ID token (set by the backend); the backend enforces it on every call.
export default function HasbroCustomerGuard({ children }) {
    const { user, loading } = useCurrentUser();
    const [customerId, setCustomerId] = useState(undefined);

    useEffect(() => {
        setCustomerId(undefined);
        if (!user) return;
        auth.currentUser?.getIdTokenResult()
            .then(r => setCustomerId(r.claims.hasbroCustomerId || null))
            .catch(() => setCustomerId(null));
    }, [user]);

    if (loading || (user && customerId === undefined)) {
        return <div className="min-h-screen flex items-center justify-center text-white/80 text-sm" style={{ background: HASBRO_BRAND.pageBg }}>Checking access…</div>;
    }
    if (!user) return <Navigate to="/login?brand=hasbro" replace />;
    if (!customerId) {
        return (
            <div className="min-h-screen flex items-center justify-center p-6" style={{ background: HASBRO_BRAND.pageBg }}>
                <div className="max-w-md w-full bg-white rounded-2xl p-8 text-center text-sm text-slate-500 shadow-2xl">
                    <img src={HASBRO_BRAND.logo} alt="Hasbro" className="w-16 h-16 rounded-2xl mx-auto mb-4 shadow-lg" />
                    <ShieldAlert size={22} className="mx-auto text-[#0087C9] mb-2" />
                    <h1 className="text-xl font-bold text-navy-900 mb-2">Access restricted</h1>
                    <p>This portal is for Hasbro customer accounts. Ask your Hasbro contact for a login.</p>
                    <button onClick={() => { localStorage.clear(); auth.signOut().finally(() => { window.location.href = "/login"; }); }}
                        className="mt-6 text-xs text-slate-400 hover:text-navy-900 underline">
                        Sign in with a different account
                    </button>
                </div>
            </div>
        );
    }
    return children;
}
